import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/HomePage/HomePage.vue'
import PlatformValue from '@/views/PlatformValue'
import ProductSystem from '@/views/ProductSystem'
import Solution from '@/views/SolutionPage.vue'
import DataVisualization from '@/views/DataVisualization'
import CooperationCases from '@/views/CooperationCases'
import AboutUs from '@/views/AboutUs'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/platform-value',
      name: 'PlatformValue',
      component: PlatformValue,
    },
    {
      path: '/product-system',
      name: 'ProductSystem',
      component: ProductSystem,
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution,
    },
    {
      path: '/data-visualization',
      name: 'DataVisualization',
      component: DataVisualization,
    },
    {
      path: '/cooperation-cases',
      name: 'CooperationCases',
      component: CooperationCases,
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs,
    },
  ],
})
